<app-loading-overlay />

@if (layout.orientation === 'vertical') {
  <app-vertical-layout>
    <div class="content-page">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
  </app-vertical-layout>
} @else {
  <app-horizontal-layout>
    <div class="content-page">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
  </app-horizontal-layout>
}
